import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) { }

  getUsers(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/user`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getRegions(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/region`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGenderChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/user/genderstatus`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getGenders(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/gender`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateUser(data: any): Observable<any> {
    const userId = data.id || data._id;
    if (!userId) throw new Error('User ID is required for update');

    const { _id, ...rest } = data;
    const payload = { id: _id || data.id, ...rest };

    return this.http.put<any>(`${apiurl}/user/${userId}`, payload)
      .pipe(
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  getLocationChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/user/location-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getAgeChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/user/age-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  
   getRegistrationChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/user/registration-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getBusinessRegistrationChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/business-profile/registration-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getPostSearchHistoryChartData(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/post/search-history-stats`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

}
